import { RouteRecordRaw, createRouter, createWebHistory } from "vue-router";
import {Management, Document} from "@element-plus/icons-vue";
import RouterLayout from "@/layout/RouterLayout.vue";
import Home from "@/Home.vue";
import NotFound from "@/NotFound.vue";
import CreatorLayout from "@/layout/CreatorLayout.vue";
import VideoList from "views/creator/course/VideoManage.vue";
import CourseDetail from "views/creator/course/CourseDetail.vue";
import CourseManage from "views/creator/course/CourseManage.vue";
import CourseCommentManage from "views/creator/course/CourseCommentManage.vue";
import CourseDiscussManage from "views/creator/course/CourseDiscussManage.vue";
import CourseApplyCenter from "views/creator/course/CourseApplyCenter.vue";
import SeriesCourseManage from "views/creator/course/SeriesCourseManage.vue";
import GroupCourseManage from "views/creator/course/GroupCourseManage.vue";
import FakeLiveDetail from "views/creator/course/FakeLiveDetail.vue";

import Privacy from "views/system/Privacy.vue";
import UploadedFilesManage from "views/creator/course/UploadedFilesManage.vue";
import TestIndex from "views/creator/test/TestIndex.vue";
import TestList from "views/creator/test/TestList.vue";
import ReelList from "views/creator/test/ReelList.vue";
import TestDetail from "views/creator/test/TestDetail.vue";
import ImageUpload from "views/creator/common/ImageUpload.vue";
import {isLogin} from "@/utils/common.ts";
import TestLayout from "@/layout/TestLayout.vue";
// import ExerciseTransform from "views/creator/test/TestTransform.vue";

export const routes: RouteRecordRaw[] = [
  {
    path: "/",
    redirect: "/index",
  },
  {
    path: "/index",
    component: Home,
    name: "Home",
  },
  {
    path: "/creator",
    component: CreatorLayout,
    children: [
      {
        path: "/creator",
        redirect: "/creator/course",
      },
      {
        path: "/creator/course",
        component: RouterLayout,
        name: "CreatorCenter",
        meta: { title: "课程管理", icon: Management, authority: [0, 1] },
        children: [
          {
            path: "/creator/course",
            redirect: "/creator/course/normal",
          },
          {
            path: "/creator/course/uploaded/files",
            meta: { title: "文件列表" },
            name: "CourseUploadedFiles",
            component: UploadedFilesManage
          },
          {
            path: "/creator/course/record/videos",
            meta: { title: "视频管理" },
            name: "RecordVideoManage",
            component: VideoList
          },
          {
            path: "/creator/course/normal",
            meta: { title: "课程管理" },
            name: "CourseManage",
            component: CourseManage,
          },
          {
            path: "/creator/course/series",
            meta: { title: "系列课管理" },
            name: "SeriesManage",
            component: SeriesCourseManage,
          },
          {
            path: "/creator/course/group",
            meta: { title: "组合课管理" },
            name: "GroupManage",
            component: GroupCourseManage,
          },
          {
            path: "/creator/course/detail/:id",
            name: "CourseDetail",
            component: CourseDetail
          },
          {
            path: "/creator/course/live/:id",
            name: "FakeLiveDetail",
            component: FakeLiveDetail
          },
          {
            path: "/creator/course/rating",
            meta: { title: "课程评价" },
            name: "CourseRating",
            component: CourseCommentManage,
          },
          {
            path: "/creator/course/discuss",
            meta: { title: "讨论区" },
            name: "CourseDiscuss",
            component: CourseDiscussManage,
          },
          {
            path: "/creator/course/apply-list",
            meta: { title: "报名中心" },
            name: "CourseApplyList",
            component: CourseApplyCenter,
          },
        ]
      },
      {
        path: "/creator/test",
        component: TestLayout,
        name: "CreatorTest",
        meta: { title: "测试管理", icon: Document, authority: [0, 2] },
        children: [
          {
            path: "/creator/test",
            redirect: "/creator/test/index",
          },
          {
            path: "/creator/test/index",
            meta: { title: "总览" },
            name: "TestIndex",
            component: TestIndex,
          },
          {
            path: "/creator/test/list",
            meta: { title: "题目列表" },
            name: "TestList",
            component: TestList,
          },
          {
            path: "/creator/test/detail/:id",
            name: "TestDetail",
            component: TestDetail,
          },
          {
            path: "/creator/reel/list",
            meta: { title: "套卷列表"},
            name: "ReelList",
            component: ReelList,
          },
          {
            path: "/creator/reel/image-upload",
            meta: { title: "图片上传"},
            name: "ImageUpload",
            component: ImageUpload,
          },
          // {
          //   path: "/creator/test/transform",
          //   meta: { title: "转题工具" },
          //   name: "ExerciseTransform",
          //   component: ExerciseTransform,
          // }
        ]
      }
    ],
  },
  {
    path: "/privacy/:name",
    component: Privacy,
    name: "Privacy",
  },
  {
    path: "/:catchAll(.*)",
    component: NotFound,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, _, next) => {
  if (to.path !== '/' && to.path !== '/index' && to.name !== 'Privacy') {
    if (!isLogin()) {
      next({
        path: '/index',
      });
    } else {
      next()
    }
  } else {
    next();
  }
})

export default router;
